export default __webpack_public_path__ + "static/media/Ma009-1.45786792.svg";